import axios from 'axios';
// import 'rxjs/add/operator/mergeMap';
// import 'rxjs/add/operator/debounceTime';
import 'rxjs';

import {
  FETCH_SALES_ORDER_SUGGESTIONS_SUCCESS,
  FETCH_SALES_ORDER_SUGGESTIONS_FAILURE,
  FETCH_SALES_ORDER_SUGGESTIONS,
  FETCH_PURCHASE_ORDER_SUGGESTIONS,
  FETCH_PURCHASE_ORDER_SUGGESTIONS_SUCCESS,
  FETCH_PURCHASE_ORDER_SUGGESTIONS_FAILURE,
  FETCH_PRODUCT_SUGGESTIONS,
  FETCH_PRODUCT_SUGGESTIONS_SUCCESS,
  FETCH_PRODUCT_SUGGESTIONS_FAILURE,
} from './type';

import {
  SALES_ORDER_SUGGESTION_URL,
  PURCHASE_ORDER_SUGGESTION_URL,
} from './url';

import {
  ROOT_URL, ROOT_API_URL, isGGI, isSH, isAP, isLMH, isLMHST
} from '../actions/root_url';

export function fetchSalesOrderSuggestions(customerNumber, searchType, value, company_id, warehouse_id, color, pkgTp = null) {
  return (dispatch) => {
    dispatch({ type: FETCH_SALES_ORDER_SUGGESTIONS, payload: { customerNumber, searchType, value, company_id, warehouse_id, color, pkgTp} });
  };
}

export const SalesAutoSuggestEpic = action$ =>
  action$.ofType(FETCH_SALES_ORDER_SUGGESTIONS)
    .switchMap(action => {
      let url = `${SALES_ORDER_SUGGESTION_URL}${action.payload.customerNumber}/?${action.payload.searchType}=${action.payload.value}&Company_id=${action.payload.company_id}&warehouse_id=${action.payload.warehouse_id}`
      if (isSH || isAP || isLMH || isLMHST) { //homecolor
        url = `${SALES_ORDER_SUGGESTION_URL}${action.payload.customerNumber}/?${action.payload.searchType}=${action.payload.value}&Company_id=${action.payload.company_id}&warehouse_id=${action.payload.warehouse_id}&Color=${action.payload.color}`;
        if((isSH || isAP) && action.payload.pkgTp !== null) {
          url = url + `&PkgType=${action.payload.pkgTp.value}`
        }
      }
      return axios.get(
        url,
        {
          headers: { Authorization: `Bearer ${localStorage.getItem('token')}` },
        },
      )
    })
    .map(response => ({ type: FETCH_SALES_ORDER_SUGGESTIONS_SUCCESS, payload: response }))
    .catch((err, source) => {
      return source;
    });

export function fetchPurchaseOrderSuggestions(searchType, value, warehouse_id, isFLTPO = false) {
  return (dispatch) => {
    dispatch({ type: FETCH_PURCHASE_ORDER_SUGGESTIONS, payload: { searchType, value, warehouse_id, isFLTPO } });
  };
}

export const PurchaseAutoSuggestEpic = action$ =>
  action$.ofType(FETCH_PURCHASE_ORDER_SUGGESTIONS)
    .switchMap(action => {
      let url = `${PURCHASE_ORDER_SUGGESTION_URL}?${action.payload.searchType}=${action.payload.value}&warehouse_id=${action.payload.warehouse_id}`;
      if(isGGI && action.payload.isFLTPO) {
        url = url + `&isFLTPO=${action.payload.isFLTPO}`
      }
      return axios.get(
        url,
        {
          headers: { Authorization: `Bearer ${localStorage.getItem('token')}` },
        },
      )
    }
      )
    .map(response => ({ type: FETCH_PURCHASE_ORDER_SUGGESTIONS_SUCCESS, payload: response }))
    .catch(err => ({ type: FETCH_PURCHASE_ORDER_SUGGESTIONS_FAILURE, payload: err }));


export function fetchProductSuggestions(searchType, value, warehouse, company_id = '', pkgTp = null) {
  return (dispatch) => {
    dispatch({ type: FETCH_PRODUCT_SUGGESTIONS, payload: { searchType, value } });
    let url = `${PURCHASE_ORDER_SUGGESTION_URL}?${searchType}=${value}&warehouse_id=${warehouse}`;
    if(isGGI && company_id) {
      url += `&company_id=${company_id}`
    }
    if((isSH || isAP) && pkgTp !== null) {
      url = url + `&PkgType=${pkgTp.value}`
    }
    return axios.get(
      url,
      {
        headers: { Authorization: `Bearer ${localStorage.getItem('token')}` },
      },
    )
    .then((response) => {
      dispatch(fetchSuccess1(response));
    }, (err) => {
      if (err.status === 500 || err.status === 404) {
        err.data = 'Something went wrong on the server. Please refresh the page or try again later. If the problem persists, please contact the development team.';
      }
      if(isGGI && err.status == 401 && err.data && err.data.detail && err.data.detail == 'Authentication credentials were not provided.'&& !location.href.endsWith('/login')) {
        document.getElementById('tokenInvalid').style.display = 'flex'
      } else {
        dispatch(fetchFailure1(err));
      }
    });
  };
}

export function fetchSuccess1(response) {
  return {
    type: FETCH_PRODUCT_SUGGESTIONS_SUCCESS,
    payload: response,
  };
}

export function fetchFailure1(error) {
  return {
    type: FETCH_PRODUCT_SUGGESTIONS_FAILURE,
    payload: error,
  };
}
// export const ProductAutoSuggestEpic = (action$, { getState }) =>
//   action$.ofType(FETCH_PRODUCT_SUGGESTIONS)
//     .switchMap(action => axios.get(
//       `${PURCHASE_ORDER_SUGGESTION_URL}?${action.payload.searchType}=${action.payload.value}&warehouse_id=${getState().header.selectedWarehouse.value}`,
//       {
//         headers: { Authorization: `Bearer ${localStorage.getItem('token')}` },
//       },
//     ))
//     .map(response => ({ type: FETCH_PRODUCT_SUGGESTIONS_SUCCESS, payload: response }))
//     .catch(err => {
//       return ({ type: FETCH_PRODUCT_SUGGESTIONS_FAILURE, payload: err })
//     });



// WEBPACK FOOTER //
// ./master/jsx/actions/autoSuggest_actions.js